<template>
  <div class="min-h-screen ml-0 w-full lg:mr-3">
    <div
      class="flex justify-start divide-x-1.5 bg-white mx-3 my-5 items-center"
    >
      <transition name="fade">
        <div
          v-if="loading"
          class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
        >
          <loader class="center-h-v" />
        </div>
      </transition>
      <router-link
        :to="{ name: 'time&attendance', params: { type: tab.route } }"
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{
          'bg-primary text-white': selectedTab == tab.name,
        }"
        class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer p-3"
      >
        {{ tab.name }}
      </router-link>
    </div>

    <transition name="fade">
      <div
        v-if="create_error"
        class="p-1 text-center text-sm w-full bg-yellow-200"
      >
        {{ create_error }}
      </div>
    </transition>

    <transition name="fade">
      <div v-if="success" class="p-1 text-center text-sm w-full bg-green-200">
        {{ success }}
      </div>
    </transition>
    <mine v-if="selectedTab == 'My Attendace'" :key="mineKey"></mine>
    <team v-if="selectedTab == 'Team Attendace'" :key="teamKey"></team>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import mine from "@/components/timeAndAttendance/mine.vue";
import team from "@/components/timeAndAttendance/team.vue";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "TimeAndAttendance",
  components: {
    Loader,
    mine,
    team,
  },
  data() {
    return {
      MyAttendance: null,
      TeamAttendance: null,
      success: null,
      create_error: null,
      loading: false,
      selectedTab: "My Attendace",
      teamKey: 0,
      mineKey: 1,
      tabs: [
        {
          name: "My Attendace",
          route: "mine",
        },
        {
          name: "Team Attendace",
          route: "team",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getClockInTime",
      "isUseClockedIn",
      "getOrganization",
      "getToken",
    ]),
  },

  watch: {
    $route(to) {
      this.tabs.forEach((tab) => {
        if (tab.route == to.params.type) {
          this.selectedTab = tab.name;
        }
      });
      switch (this.selectedTab) {
        case "My Attendace":
          this.mineKey++;
          break;
        case "Team Attendace":
          this.teamKey++;
          break;
      }
    },
  },
};
</script>
